module.exports = __webpack_public_path__ + "static/media/Student-Registration.ed124300.png";